export default __webpack_public_path__ + "static/media/a037-student-t3-s3-6.86ab9d6a.svg";